import { React, useContext } from "react";

import { SearchOutlined } from "@ant-design/icons";
import logo from "../assests/logo.png";
import "./Header.css";
import { Link } from "react-router-dom";

import { VideoContext } from "../Helper/Context";
import {UploadModal }from "./UploadModal";

function Header() {



  // Update the document title using the browser API
  const myVideos = useContext(VideoContext);
  var timeoutID = 0;

  function onChangeSearch(value) {
    // value.preventDefault()

    if (value === "") {
      myVideos.setChange(true);
    }
    const filteredList = myVideos.result.filter((text) =>
      text.title.toUpperCase().includes(value.toUpperCase())
    );
    myVideos.setVideo(filteredList);
  }

  const debounceSearch = (value) => {
    // e.preventDefault()

    // eslint-disable-next-line eqeqeq
    if (timeoutID) {
      clearTimeout(timeoutID);
    }

    timeoutID = setTimeout(() => {
      onChangeSearch(value);
    }, 300);
  };



  return (
    <div className="header">
      <Link to="/" className="left_header">
        <img src={logo} className="header__logo" alt="X Flix Logo" />
      </Link>
      <div className="input_header">
        <input
          className="input_btn"
          placeholder="Search"
          // value={Event.target.value}
          onChange={(e) => debounceSearch(e.target.value)}
        />

        <SearchOutlined className="input_btn" />
      </div>
      <div id="upload-btn" className="upload">
         <UploadModal />
      </div>
     
    </div>
    
  );
}

export { Header };
